import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ProductPriceCart } from './ProductPriceCart';
import { Input } from '../General/Input';
import { SvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  name: string;
  imgSrc: string | null;
  price: string;
  oldPrice: string;
  unit: string;
  url: string;
  addToRequest: any;
  addToCart: any;
  isLoggedIn: boolean;
  isInCart: boolean;
  theme: any;
}

function ProductTabRow({
  name,
  imgSrc,
  url,
  price,
  oldPrice,
  unit,
  addToCart,
  addToRequest,
  isLoggedIn,
  isInCart,
  theme,
}: Props) {
  return (
    <Wrapper>
      <LeftWrapper>
        <ImageWrapper to={url}>
          <Image
            alt={`Obrázok ku produktu ${name}`}
            src={imgSrc ? imgSrc : '/images/zemplin/placeholder.svg'}
          />
          {isInCart && (
            <SvgIcon
              width={16}
              height={16}
              icon={IconType.cart}
              fill={theme.colors.primary}
              marginLeft={8}
              alt={__('Produkt sa nachádza v košíku')}
              title={__('Produkt sa nachádza v košíku')}
            />
          )}
        </ImageWrapper>
        <NameInputWrapper>
          <Link to={url}>
            <Name>{name}</Name>
          </Link>
          <OrderNrInput type="text" name="ordernr" />
        </NameInputWrapper>
        <StockCount>Skladom 0,999 Mks</StockCount>
      </LeftWrapper>
      <ProductPriceCart
        price={price}
        oldPrice={oldPrice}
        unit={unit}
        addToRequest={addToRequest}
        addToCart={addToCart}
        withVat={!isLoggedIn}
        noStock={false}
        isInCart={isInCart}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin: ${rem(48)} ${rem(32)};
  padding: 0 0 ${rem(48)};
  border-radius: ${rem(2)};
  margin-right: ${rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: space-between;

  ${({ theme }) => theme.mediab.l925`
    width: 95%;
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    max-width: initial;
    width: 100%;
    &:last-child {
      margin: 0 auto;
    }
  `}
`;

const StockCount = styled.span`
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.colors.stockCountAvailable};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(22)};
  width: 100%;
  text-align: left;
  margin-bottom: ${rem(11)};
`;

const OrderNrInput = styled(Input)`
  max-width: ${rem(166)};
  width: 100%;
  height: ${rem(32)};
  margin-right: auto;
  margin-bottom: ${rem(14)};
  color: ${({ theme }) => theme.colors.black};
`;

const LeftWrapper = styled(FlexRowCenterVertical)`
  width: 50%;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(24)};
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: ${rem(48)};
`;

const NameInputWrapper = styled(FlexCol)`
  margin-right: ${rem(32)};
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(12)};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
  width: ${rem(250)};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const WithTheme: any = withTheme(ProductTabRow);
export { WithTheme as ProductTabRow };
